import { SingleRecordDetailsInterface } from '@/interfaces/SingleRecordDetailsInterface';

export default class SampleRecordHelper {
    private sampleRecords = [
        {
            id: '72505',
            prodGroup: 't',
            brand: {
                id: '10903',
                importId: 45792,
                isTrademark: true,
                isCustomerRelation: false,
                isGoodwill: false,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Thai Union Group PCL',
                brandBusinessComb: 'King Oscar Holding AS',
                activities:
                    "Acquisition of 100 percent of the assets and the trademark of the world's top ten " +
                    "seafood brand*- ‘King Oscar', originating from Norway with a strong brand heritage of more " +
                    'than 140 years. King Oscar Holding AS is owned by the private equity fund Procuritas Capital ' +
                    "Investors IV in the Nordic Region. ‘King Oscar', number one in premium sardine category in," +
                    ' Norway, USA and Australia posted sales of USD 80 million with EBITDA margin of around 12 ' +
                    'percent in 2013. As one of the leading canned fish suppliers in Norway, USA, Poland, Belgium ' +
                    'and Australia, King Oscar has an average growth rate of 6 percent per annum for the past five' +
                    " years. With a headquarter in Bergen, Norway, ‘King Oscar' has two world-class production " +
                    'facilities in Poland (Gniewino) and Norway (Svolvær) with a total combined production capacity' +
                    ' of 135 million cans and a workforce of 500 people, producing and selling 90 million cans per ' +
                    'year covering 16 markets globally. It is amongst the top ten strongest seafood brands in ' +
                    'the world.',
                activitiesMain: 'seafood; canned sardines',
                valuationYear: 2014,
                totalAssets: '2885',
                enterpriseValue: '2383',
                revenues: '1580',
                trademarkValue: '617',
                usefulLifetime: null,
                customerValue: '0',
                lifetimeCv: '10',
                goodwill: '158.997',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '',
                royaltyRateReported: null,
                trademarkValuationEV: '',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: '125',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '12.712',
                tangibles: '11.664',
                trademarkPerRevenue: '0',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '15.911133333333',
                trademarkPerTotalAssets: '0',
                customerRelationPerTotalAssets: '0.30037275706693',
                otherIntangiblesPerTotalAssets: '0.048500387255295',
                goodwillPerTotalAssets: '0.60662492703195',
                tangiblesPerTotalAssets: '0.044501928645827',
                trademarkPerEV: '0',
                customerRelationPerEV: '0.32986546108176',
                otherIntangiblesPerEV: '0.053262495443442',
                goodwillPerEV: '0.6661876170564',
                tangiblesPerEV: '0.048871440123687',
                sum: '1.0981870137053',
                corpTax: '0.25',
                usdRevenues: '15',
                usdBrandVal: '',
                implRoyaltyRateCautR: '',
                implRoyaltyRateOptR: '',
                implRoyaltyRateAvgR: '',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '5.2485333333333',
                custValueUSD: '78.728',
                custTab: true,
                ndCust: '10',
                implCustMargCaut: '1.2175740747234',
                implCustMargOpt: '0.96453458462017',
                implCustMargAvg: '1.0910543296718',
                attritionRate: '0.095162582015334',
                marginType: 'excess earnings margin',
                gwRev: '10.5998',
                gwUsd: '158.997',
                gwTab: false,
                implGwMargCaut: '0.076160864864565',
                implGwMargOpt: '0.052242520712299',
                implGwMargAvg: '0.064201692788432',
                gwPerStaffThUsd: '',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                createdAt: '2019-08-01T19:04:57+02:00',
                updatedAt: '2019-09-09T13:04:16+02:00',
                valuerCountry: {
                    type: 'countries',
                    id: '205',
                    code: 'TH',
                    isEU: false,
                    isG7: false,
                    isG20: false,
                    vat: 0,
                    name: 'Thailand',
                },
                brandCountry: {
                    type: 'countries',
                    id: '157',
                    code: 'NO',
                    isEU: false,
                    isG7: false,
                    isG20: false,
                    vat: 0,
                    name: 'Norway',
                },
                valuationCause: { name: 'PPA - share deal' },
                concept: { name: 'fair value' },
                territory: {
                    comment: 'on the continent surrounding the home country',
                    name: 'international',
                },
                currency: {
                    code: 'THB',
                    name: 'Thailand Baht',
                },
                revenueType: {
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '0.048500387255295',
                swPerEV: '0.053262495443442',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
            },
            projects: [
                {
                    createdAt: '2019-09-24T13:00:50+02:00',
                    name: 'sample records',
                },
            ],
        },
        {
            id: '72506',
            prodGroup: 't',
            brand: {
                id: '11414',
                importId: 47352,
                isTrademark: true,
                isCustomerRelation: true,
                isGoodwill: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Royal Caribbean Cruises Ltd.',
                brandBusinessComb: 'Silversea Cruise Holding Ltd.',
                activities:
                    'Silversea Cruises, Ltd. owns and operates luxury cruises and smaller ' +
                    'cruise ships. It operates luxury cruise ships to various destinations worldwide. ' +
                    'The company was founded in 1994 and is based in Monaco. It has branch offices in the' +
                    ' United States, the United Kingdom, Germany, Australia, and Singapore. Silversea Cruises ' +
                    'is a pioneer and leader in ultra-luxury and expedition cruising. Silversea Cruises, which ' +
                    "is chaired by Manfredi Lefebvre d'Ovidio, is recognized as an innovator in the ultra-luxury " +
                    'cruise line industry, offering guests large-ship amenities aboard its intimate, all-suite ' +
                    'vessels: Silver Wind, Silver Shadow, Silver Whisper, Silver Spirit and Silver' +
                    ' Muse – all designed to offer an atmosphere of conviviality and casual elegance. With ' +
                    'the inclusion of the expedition ships Silver Explorer, Silver Galapagos, Silver Discoverer,' +
                    ' and with Silver Cloud recently joining the Expedition fleet and two ships on order plus one' +
                    " option Silversea's itineraries encompass all seven continents and feature worldwide luxury " +
                    'cruises to the Mediterranean, Caribbean, both polar regions and hundreds of fascinating' +
                    ' destinations in between. Silversea has an intimate, all-suite ships, full spectrum of global ' +
                    'cruise offerings sailing to more than 1000 global destinations, and unique luxury expedition' +
                    ' vessels. ',
                activitiesMain: 'travel; tourism; luxury cruise vacations; ',
                valuationYear: 2018,
                totalAssets: '2955.478',
                enterpriseValue: '2262.691',
                revenues: '300',
                trademarkValue: '349.5',
                usefulLifetime: null,
                customerValue: '97.4',
                lifetimeCv: '15',
                goodwill: '1090.01',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.096263382831666',
                royaltyRateReported: null,
                trademarkValuationEV: '0.15446209844826',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: '2335',
                contingentOrEarnout: '44',
                comments: null,
                otherIntangibles: '47.7',
                tangibles: '1370.868',
                trademarkPerRevenue: '1.165',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '7.5423033333333',
                trademarkPerTotalAssets: '0.11825498278113',
                customerRelationPerTotalAssets: '0.032955751996801',
                otherIntangiblesPerTotalAssets: '0.016139521255107',
                goodwillPerTotalAssets: '0.3688100537375',
                tangiblesPerTotalAssets: '0.46383969022947',
                trademarkPerEV: '0.15446209844826',
                customerRelationPerEV: '0.043046089810761',
                otherIntangiblesPerEV: '0.021081093264613',
                goodwillPerEV: '0.48173170795305',
                tangiblesPerEV: '0.60585736187575',
                sum: '1.3061783513524',
                corpTax: '0',
                usdRevenues: '300',
                usdBrandVal: '349.5',
                implRoyaltyRateCautR: '0.11352616115259',
                implRoyaltyRateOptR: '0.079000604510747',
                implRoyaltyRateAvgR: '0.096263382831666',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '0.32466666666667',
                custValueUSD: '97.4',
                custTab: true,
                ndCust: '15',
                implCustMargCaut: '0.053926620757971',
                implCustMargOpt: '0.042197712085083',
                implCustMargAvg: '0.048062166421527',
                attritionRate: '0.064493015003737',
                marginType: 'distributor margin',
                gwRev: '3.6333666666667',
                gwUsd: '1090.01',
                gwTab: true,
                implGwMargCaut: '0.43203674905731',
                implGwMargOpt: '0.3044743769044',
                implGwMargAvg: '0.36825556298085',
                gwPerStaffThUsd: '466.81370449679',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '0.019445872193773',
                synergiePerEV: '',
                acqPremPerEV: '',
                createdAt: '2019-08-01T19:04:59+02:00',
                updatedAt: '2019-09-09T13:04:16+02:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                brandCountry: {
                    type: 'countries',
                    id: '130',
                    code: 'MC',
                    isEU: false,
                    isG7: false,
                    isG20: false,
                    vat: 0,
                    name: 'Monaco',
                },
                valuationCause: { name: 'PPA - share deal' },
                concept: { name: 'fair value' },
                territory: {
                    comment: 'on the continent surrounding the home country',
                    name: 'international',
                },
                currency: {
                    code: 'USD',
                    name: 'United States Dollar',
                },
                revenueType: {
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
            },
            projects: [
                {
                    createdAt: '2019-09-24T13:00:50+02:00',
                    name: 'sample records',
                },
            ],
        },
        {
            id: '72507',
            prodGroup: 't',
            brand: {
                id: '11500',
                importId: 30834,
                isTrademark: true,
                isCustomerRelation: false,
                isGoodwill: false,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Libbey Inc.',
                brandBusinessComb:
                    'B.V. Koninklijke Nederlandsche Glasfabriek Leerdam (Royal Leerdam)',
                activities:
                    'B.V. Koninklijke Nederlandsche Glasfabriek Leerdam (Royal Leerdam) manufactures ' +
                    'and markets high quality glass stemware, including popular wine glasses. It operates a ' +
                    'manufacturing and distribution facility in Leerdam, The Netherlands, and employs approximately ' +
                    '450 associates. Royal Leerdam produces and markets glass tableware for use in retail/home and ' +
                    'food service markets. Its products include novelties; drinkware, including tumblers, wine ' +
                    'glasses, etc.; kitchenware, such as oven and bakeware, and storageware; and tableware, ' +
                    'including dinnerware and serveware. The company was founded in 1878 and is based in Leerdam, ' +
                    'the Netherlands. Its subsidiary, Royal Leerdam Crystal BV, designs and produces crystal art,' +
                    ' decorative, and functional objects. It offers business gifts, including bookends, books and ' +
                    'crystalcheques, bottles, bowls, candleholders, chairman’s hammers, clocks, decanters' +
                    ' and glasses, carafes, objects, paperweights, sundials, and vases.',
                activitiesMain:
                    'durable consumer goods; glassware; glass tableware; crystalware',
                valuationYear: 2002,
                totalAssets: 'nd',
                enterpriseValue: '44.1',
                revenues: '50',
                trademarkValue: '4.2',
                usefulLifetime: null,
                customerValue: '0',
                lifetimeCv: null,
                goodwill: '5.5',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.0088520420076388',
                royaltyRateReported: null,
                trademarkValuationEV: '0.095238095238095',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: null,
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '1',
                tangibles: '',
                trademarkPerRevenue: '0.084',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '0.882',
                trademarkPerTotalAssets: '',
                customerRelationPerTotalAssets: '',
                otherIntangiblesPerTotalAssets: '',
                goodwillPerTotalAssets: '',
                tangiblesPerTotalAssets: '',
                trademarkPerEV: '0.095238095238095',
                customerRelationPerEV: '0',
                otherIntangiblesPerEV: '0.022675736961451',
                goodwillPerEV: '0.12471655328798',
                tangiblesPerEV: '',
                sum: '',
                corpTax: '0.345',
                usdRevenues: '50',
                usdBrandVal: '4.2',
                implRoyaltyRateCautR: '0.010522919614796',
                implRoyaltyRateOptR: '0.0071811644004815',
                implRoyaltyRateAvgR: '0.0088520420076388',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '0',
                custValueUSD: '0',
                custTab: true,
                ndCust: '',
                implCustMargCaut: '',
                implCustMargOpt: '',
                implCustMargAvg: '',
                attritionRate: '',
                marginType: '',
                gwRev: '0.11',
                gwUsd: '5.5',
                gwTab: true,
                implGwMargCaut: '0.01709578913406',
                implGwMargOpt: '0.01162583034226',
                implGwMargAvg: '0.01436080973816',
                gwPerStaffThUsd: '',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                createdAt: '2019-08-01T19:04:39+02:00',
                updatedAt: '2019-09-09T13:04:15+02:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                brandCountry: {
                    type: 'countries',
                    id: '156',
                    code: 'NL',
                    isEU: true,
                    isG7: false,
                    isG20: false,
                    vat: 0.21,
                    name: 'Netherlands',
                },
                valuationCause: { name: 'PPA - share deal' },
                concept: { name: 'fair value' },
                territory: {
                    comment: 'on the continent surrounding the home country',
                    name: 'international',
                },
                currency: {
                    code: 'USD',
                    name: 'United States Dollar',
                },
                revenueType: {
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
            },
            projects: [
                {
                    createdAt: '2019-09-24T13:00:50+02:00',
                    name: 'sample records',
                },
            ],
        },
        {
            id: '72512',
            prodGroup: 'c',
            brand: {
                id: '11392',
                importId: 47286,
                isTrademark: true,
                isCustomerRelation: true,
                isGoodwill: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'LyondellBasell Industries NV',
                brandBusinessComb: 'A. Schulman, Inc.',
                activities:
                    'A. Schulman, Inc. (NASDAQ: SHLM) is a leading global ' +
                    'supplier of high-performance plastic compounds, composites and powders.' +
                    ' A. Schulman, Inc. is a leading international supplier of high-performance ' +
                    'plastic compounds, composites and resins headquartered in Akron, Ohio. Since ' +
                    "1928, the company has been providing innovative solutions to meet its customers' " +
                    "demanding requirements. The company's customers span a wide range of markets, such as " +
                    'packaging, mobility, building & construction, electronics & electrical, agriculture, personal ' +
                    'care & hygiene, sports, leisure & home, custom services and others. The company employs ' +
                    'approximately 5,100 people and has 54 manufacturing facilities globally.',
                activitiesMain:
                    'chemicals; high-performance plastic compounds, composites, resins and powders',
                valuationYear: 2018,
                totalAssets: '3186',
                enterpriseValue: '2413',
                revenues: '2500',
                trademarkValue: '104',
                usefulLifetime: '5',
                customerValue: '300',
                lifetimeCv: '15',
                goodwill: '1271',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.011123512265908',
                royaltyRateReported: null,
                trademarkValuationEV: '0.043099875673436',
                profit: '205',
                costSynergies: '150',
                acqPremium: '0.09',
                staffMembers: '5100',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '101',
                tangibles: '1410',
                trademarkPerRevenue: '0.0416',
                enterpriseValuePerProfit: '11.770731707317',
                enterpriseValuePerRevenue: '0.9652',
                trademarkPerTotalAssets: '0.032642812303829',
                customerRelationPerTotalAssets: '0.094161958568738',
                otherIntangiblesPerTotalAssets: '0.031701192718142',
                goodwillPerTotalAssets: '0.39893283113622',
                tangiblesPerTotalAssets: '0.44256120527307',
                trademarkPerEV: '0.043099875673436',
                customerRelationPerEV: '0.1243265644426',
                otherIntangiblesPerEV: '0.04185661002901',
                goodwillPerEV: '0.52673021135516',
                tangiblesPerEV: '0.58433485288023',
                sum: '1.3203481143804',
                corpTax: '0.21',
                usdRevenues: '2500',
                usdBrandVal: '104',
                implRoyaltyRateCautR: '0.011722948511319',
                implRoyaltyRateOptR: '0.010524076020496',
                implRoyaltyRateAvgR: '0.011123512265908',
                implRoyaltyRateCaut0: '0.020151992088868',
                implRoyaltyRateOpt0: '0.018688855300896',
                implRoyaltyRateAvg0: '0.019420423694882',
                custValueRevenue: '0.12',
                custValueUSD: '300',
                custTab: true,
                ndCust: '15',
                implCustMargCaut: '0.022780744099404',
                implCustMargOpt: '0.017392207919832',
                implCustMargAvg: '0.020086476009618',
                attritionRate: '0.064493015003737',
                marginType: 'excess earnings margin',
                gwRev: '0.5084',
                gwUsd: '1271',
                gwTab: true,
                implGwMargCaut: '0.069745137847622',
                implGwMargOpt: '0.048150304000265',
                implGwMargAvg: '0.058947720923944',
                gwPerStaffThUsd: '249.21568627451',
                synergieValue: '1200',
                acqPrmValue: '217.17',
                earnoutPerEV: '',
                synergiePerEV: '0.49730625777041',
                acqPremPerEV: '0.09',
                createdAt: '2019-08-01T19:04:59+02:00',
                updatedAt: '2019-09-09T13:04:16+02:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                brandCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                valuationCause: { name: 'PPA - share deal' },
                concept: { name: 'fair value' },
                territory: {
                    comment: 'on the continent surrounding the home country',
                    name: 'international',
                },
                currency: {
                    code: 'USD',
                    name: 'United States Dollar',
                },
                revenueType: {
                    name: 'revenues from sales of products or services',
                },
                profitType: { name: 'EBITDA' },
            },
            projects: [
                {
                    createdAt: '2019-09-24T14:18:32+02:00',
                    name: 'customer sample',
                },
            ],
        },
        {
            id: '72513',
            prodGroup: 'c',
            brand: {
                id: '11211',
                importId: 46743,
                isTrademark: true,
                isCustomerRelation: true,
                isGoodwill: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Knight-Swift Transportation Holdings, Inc.',
                brandBusinessComb: 'Swift Transportation Co.',
                activities:
                    'Swift is a multi-faceted transportation ' +
                    'services company, operating one of the largest ' +
                    'fleets of truckload equipment in North America from' +
                    ' over 40 terminals near key freight centers and ' +
                    'traffic lanes. We principally operate in short- to ' +
                    'medium-haul traffic lanes around our terminals and' +
                    ' dedicated customer locations. During 2016, our consolidated average operational truck count was' +
                    ' 17,548, which along with our intermodal containers ' +
                    'covered 2.2 billion miles for shippers throughout' +
                    ' North America, contributing to consolidated operating revenue of $4.0 billion and consolidated ' +
                    'operating income of $242.0 million. As of December 31, 2016, our fleet was comprised of 13,937' +
                    ' company tractors and 4,429 owner-operator tractors, as well as 64,066 trailers, and 9,131 ' +
                    'intermodal containers. Our customers have the ' +
                    'opportunity to "one-stop-shop" for their truckload ' +
                    'transportation needs with our extensive suite of service offerings, which includes line-haul ' +
                    'services, dedicated customer contracts, ' +
                    'temperature-controlled units, intermodal freight solutions, ' +
                    'cross-border United States/Mexico and United States/Canada freight, flatbed hauling, ' +
                    'freight brokerage and logistics, and ' +
                    'others. Our four reportable segments are Truckload, Dedicated,' +
                    ' Swift Refrigerated, and Intermodal. ' +
                    'Our customers are typically large corporations in the retail ' +
                    '(including discount and online retail), food and beverage, consumer products, paper products, ' +
                    'transportation and logistics, housing and building, automotive, and manufacturing industries. ' +
                    'Many of our customers have extensive ' +
                    'operations, geographically distributed locations, and diverse ' +
                    'shipping needs. Customer satisfaction is' +
                    ' an important priority for us, which is demonstrated by the' +
                    ' numerous "carrier of the year" or ' +
                    'similar awards received from our customers over the past several' +
                    ' years. One customer, Wal-Mart, accounted for more than 10% of our operating revenue.',
                activitiesMain: 'transportation; truckload carrier ',
                valuationYear: 2017,
                totalAssets: '6427.346',
                enterpriseValue: '4843.102',
                revenues: '3723',
                trademarkValue: '635.2',
                usefulLifetime: null,
                customerValue: '816.5',
                lifetimeCv: '20',
                goodwill: '2844.82',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.019012523314429',
                royaltyRateReported: null,
                trademarkValuationEV: '0.13115561059833',
                profit: '527',
                costSynergies: '75',
                acqPremium: null,
                staffMembers: '21800',
                contingentOrEarnout: null,
                comments: 'Reverse acquisition.',
                otherIntangibles: '2.2737367544323E-13',
                tangibles: '2130.826',
                trademarkPerRevenue: '0.17061509535321',
                enterpriseValuePerProfit: '9.1899468690702',
                enterpriseValuePerRevenue: '1.3008600590921',
                trademarkPerTotalAssets: '0.098827727649951',
                customerRelationPerTotalAssets: '0.12703532686742',
                otherIntangiblesPerTotalAssets: '3.5375981850554E-17',
                goodwillPerTotalAssets: '0.44261192722471',
                tangiblesPerTotalAssets: '0.33152501825792',
                trademarkPerEV: '0.13115561059833',
                customerRelationPerEV: '0.16859029605406',
                otherIntangiblesPerEV: '4.694794275306E-17',
                goodwillPerEV: '0.58739625966994',
                tangiblesPerEV: '0.43997132416373',
                sum: '1.3271134904861',
                corpTax: '0.4',
                usdRevenues: '3723',
                usdBrandVal: '635.2',
                implRoyaltyRateCautR: '0.022636407632917',
                implRoyaltyRateOptR: '0.01538863899594',
                implRoyaltyRateAvgR: '0.019012523314429',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '0.21931238248724',
                custValueUSD: '816.5',
                custTab: true,
                ndCust: '20',
                implCustMargCaut: '0.045054157059976',
                implCustMargOpt: '0.032540715335642',
                implCustMargAvg: '0.038797436197809',
                attritionRate: '0.048770575526248',
                marginType: 'excess earnings margin',
                gwRev: '0.76412033306473',
                gwUsd: '2844.82',
                gwTab: true,
                implGwMargCaut: '0.12618125979886',
                implGwMargOpt: '0.085215101647765',
                implGwMargAvg: '0.10569818072331',
                gwPerStaffThUsd: '130.49633027523',
                synergieValue: '600',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '0.12388754149716',
                acqPremPerEV: '',
                createdAt: '2019-08-01T19:04:58+02:00',
                updatedAt: '2019-09-09T13:04:16+02:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                brandCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                valuationCause: { name: 'PPA - share deal' },
                concept: { name: 'fair value' },
                territory: {
                    comment: 'on the continent surrounding the home country',
                    name: 'international',
                },
                currency: {
                    code: 'USD',
                    name: 'United States Dollar',
                },
                revenueType: {
                    name: 'revenues from sales of products or services',
                },
                profitType: { name: 'EBITDA' },
            },
            projects: [
                {
                    createdAt: '2019-09-24T14:18:32+02:00',
                    name: 'customer sample',
                },
            ],
        },
        {
            id: '72514',
            prodGroup: 'c',
            brand: {
                id: '11113',
                importId: 46422,
                isTrademark: true,
                isCustomerRelation: true,
                isGoodwill: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'ADT Inc.',
                brandBusinessComb: 'The ADT Corp.',
                activities:
                    'The ADT Corporation (NYSE:ADT) is a leading provider of security and automation ' +
                    "solutions for homes and businesses in the United States and Canada. ADT's broad and pioneering" +
                    ' set of products and services, including ADT Pulse® interactive home' +
                    ' and business solutions, and ' +
                    'health services, meet a range of customer needs for today’s active and increasingly mobile ' +
                    'lifestyles. Headquartered in Boca Raton, Florida, ADT helps provide peace of mind to over ' +
                    '6.5 million customers and employs approximately 17,000 people at 200 locations. ADT is the' +
                    ' leading provider of monitored security, interactive home and business automation and ' +
                    'related monitoring services in the United States and Canada. Our mission is to help our ' +
                    'customers protect and connect to what matters most—their families, homes, and businesses. ' +
                    'The ADT brand is synonymous with security and, as the most recognized and trusted brand in the ' +
                    'industry, is a key driver of our success. A 2017 survey found that the ADT ' +
                    'brand had approximately ' +
                    '95% brand awareness, and nearly half of ADT customers surveyed did not' +
                    ' consider any other security ' +
                    'alarm provider during their purchase process. We estimate that we are ' +
                    'approximately five times ' +
                    'larger than the next largest residential competitor, with an approximate' +
                    ' 30% market share of the ' +
                    'residential monitored security industry in the United States and Canada. Excluding contracts' +
                    ' monitored but not owned, we currently serve approximately 7.2 million residential and business ' +
                    'customers, making us the largest company of our kind in the' +
                    ' United States and Canada. We are one ' +
                    'of the largest full-service companies with a national footprint providing both residential and ' +
                    'commercial monitored security. We deliver an integrated customer experience by maintaining the ' +
                    'industry’s largest sales, installation, and service field force, as well as a 24/7 professional ' +
                    'monitoring network, all supported by approximately 18,000 ' +
                    'employees visiting approximately 10,000 ' +
                    'homes and businesses daily. We handle approximately 15 ' +
                    'million alarms annually. We provide support' +
                    ' from over 200 sales and service locations and through our 12 monitoring centers listed by' +
                    'Underwriters Laboratories (“U.L.”). More than 90% of our revenue is recurring from ' +
                    'contractually-committed monthly payments under customer contract terms that are generally three' +
                    ' to five years in length and where the average customer ' +
                    'tenure exceeds the initial contract term.' +
                    ' We offer our residential, commercial, and multi-site ' +
                    'customers a comprehensive set of burglary, ' +
                    'video, access control, fire and smoke alarm, and medical alert solutions. Our 24/7 monitoring ' +
                    'capabilities are enabled by our 12 monitoring centers listed by U.L., which ensure that any ' +
                    'detected threats are met with a rapid response by a trained ADT professional. Our core ' +
                    'professional monitored security offering is complemented by a broad set of innovative products ' +
                    'and services, including interactive home and business automation solutions that are designed ' +
                    'to control access, react to movement, and sense carbon monoxide, flooding, and changes in ' +
                    'temperature' +
                    ' or other environmental conditions, as well as address personal emergencies, such as injuries,' +
                    ' medical incidents or incapacitation. ADT has a long legacy ' +
                    'as a trusted and innovative security ' +
                    'service provider for homes and businesses. Now an iconic ' +
                    'American brand, ADT’s history began in' +
                    ' 1874, when it was established as The American District Telegraph Company, embracing the most ' +
                    'advanced communications technology of the 1800s. A core' +
                    ' aspect of ADT’s success over our more than ' +
                    '140-year history has been our culture of technological ' +
                    'and service innovations that have allowed ' +
                    'us to remain a market leader and to pursue our core mission of keeping our customers safe and ' +
                    'their property protected. Over the last 20 years we have continued to bring new products and ' +
                    'services to market to meet changing customer needs and make use of newly emerging technologies. ' +
                    'In 2001, we became the first security company to offer a web-enabled home security system, ADT' +
                    ' Safewatch iCenter. We diversified our offerings further with the introduction of the ADT ' +
                    'Companion Services System, designed to make sure people could live comfortably and safely ' +
                    'in their own homes for as long as possible. In 2010, we launched ADT Pulse, making it ' +
                    'possible to meet the expanding customer security, professional monitoring, and interactive' +
                    ' automation needs for today’s increasingly active, mobile, and technology-centered lifestyles. ' +
                    'ADT also continues to innovate through partnerships with leading technology providers.',
                activitiesMain:
                    'security and automation solutions for homes and businesses; monitored security, ' +
                    'interactive home and business automation services',
                valuationYear: 2016,
                totalAssets: '15189.374',
                enterpriseValue: '12082.767',
                revenues: '3750',
                trademarkValue: '1333',
                usefulLifetime: null,
                customerValue: '4676',
                lifetimeCv: '6',
                goodwill: '4126.512',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.039611490844413',
                royaltyRateReported: null,
                trademarkValuationEV: '0.11032241207664',
                profit: '1800',
                costSynergies: null,
                acqPremium: '0.56',
                staffMembers: '17000',
                contingentOrEarnout: null,
                comments: 'Acquisition of ADT by Apollo Global Management.',
                otherIntangibles: '1569.564',
                tangibles: '3484.298',
                trademarkPerRevenue: '0.35546666666667',
                enterpriseValuePerProfit: '6.7126483333333',
                enterpriseValuePerRevenue: '3.2220712',
                trademarkPerTotalAssets: '0.087758718693739',
                customerRelationPerTotalAssets: '0.30784678815598',
                otherIntangiblesPerTotalAssets: '0.10333302741772',
                goodwillPerTotalAssets: '0.27167097208878',
                tangiblesPerTotalAssets: '0.22939049364378',
                trademarkPerEV: '0.11032241207664',
                customerRelationPerEV: '0.3869974485149',
                otherIntangiblesPerEV: '0.1299010400515',
                goodwillPerEV: '0.34152044808942',
                tangiblesPerEV: '0.28836921211838',
                sum: '1.2571105608508',
                corpTax: '0.4',
                usdRevenues: '3750',
                usdBrandVal: '1333',
                implRoyaltyRateCautR: '0.047161643874026',
                implRoyaltyRateOptR: '0.0320613378148',
                implRoyaltyRateAvgR: '0.039611490844413',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '1.2469333333333',
                custValueUSD: '4676',
                custTab: true,
                ndCust: '6',
                implCustMargCaut: '0.43875307825553',
                implCustMargOpt: '0.35829006038015',
                implCustMargAvg: '0.39852156931784',
                attritionRate: '0.15351827518936',
                marginType: 'excess earnings margin',
                gwRev: '1.1004032',
                gwUsd: '4126.512',
                gwTab: true,
                implGwMargCaut: '0.18171256025317',
                implGwMargOpt: '0.12271754393111',
                implGwMargAvg: '0.15221505209214',
                gwPerStaffThUsd: '242.736',
                synergieValue: '',
                acqPrmValue: '6766.34952',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '0.56',
                createdAt: '2019-08-01T19:04:58+02:00',
                updatedAt: '2019-09-09T13:04:16+02:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                brandCountry: {
                    type: 'countries',
                    id: '220',
                    code: 'US',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                },
                valuationCause: { name: 'PPA - share deal' },
                concept: { name: 'fair value' },
                territory: { comment: 'home country', name: 'national' },
                currency: {
                    code: 'USD',
                    name: 'United States Dollar',
                },
                revenueType: {
                    name: 'revenues from sales of products or services',
                },
                profitType: { name: 'EBITDA' },
            },
            projects: [
                {
                    createdAt: '2019-09-24T14:18:32+02:00',
                    name: 'customer sample',
                },
            ],
        },
        {
            id: '50571',
            prodGroup: 'g',
            brand: {
                type: 'brands',
                id: '12492',
                importId: 50571,
                isTrademark: true,
                isCustomerRelation: true,
                isGoodwill: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Medicover AB',
                brandBusinessComb: 'Spitalul Pelican',
                activities:
                    'Spitalul Pelican is the major hospital operator in Oradea, a city of ' +
                    'around 200,000 people in the north-western part of Romania. The agreement is ' +
                    'for an 80% stake of the hospital and clinical business of Pelican. Pelican ' +
                    'has a fully equipped hospital with 130 beds, 5 operating theatres, ' +
                    'imaging diagnostics and supporting activities. Established in 1992' +
                    ' by leading surgeons it is the foremost healthcare provider in the' +
                    'north-western part of Romania. The company is currently underway expanding ' +
                    'a further 4,000 square-meter new-build adjacent facility, adding some 100 beds ' +
                    'and a research facility. This will also include the area of highly specialised care ' +
                    'such as interventional cardiology or 3D laparoscopic surgery since there are no other ' +
                    'similar private providers.',
                activitiesMain: 'health care services; hospital operator',
                valuationYear: 2018,
                totalAssets: '43.5',
                enterpriseValue: '26.8',
                revenues: '18.5',
                trademarkValue: '7.5',
                usefulLifetime: '7',
                customerValue: '1.7',
                lifetimeCv: '10',
                goodwill: '12.8',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.080530402588508',
                royaltyRateReported: null,
                trademarkValuationEV: '0.27985074626866',
                profit: '3.7',
                costSynergies: null,
                acqPremium: null,
                staffMembers: '400',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '0.6',
                tangibles: '20.9',
                trademarkPerRevenue: '0.40540540540541',
                enterpriseValuePerProfit: '7.2432432432432',
                enterpriseValuePerRevenue: '1.4486486486486',
                trademarkPerTotalAssets: '0.17241379310345',
                customerRelationPerTotalAssets: '0.039080459770115',
                otherIntangiblesPerTotalAssets: '0.013793103448276',
                goodwillPerTotalAssets: '0.29425287356322',
                tangiblesPerTotalAssets: '0.48045977011494',
                trademarkPerEV: '0.27985074626866',
                customerRelationPerEV: '0.063432835820896',
                otherIntangiblesPerEV: '0.022388059701493',
                goodwillPerEV: '0.47761194029851',
                tangiblesPerEV: '0.77985074626866',
                sum: '1.6231343283582',
                corpTax: '0.16',
                usdRevenues: '21.8476675',
                usdBrandVal: '8.8571625',
                implRoyaltyRateCautR: '0.08587262627474',
                implRoyaltyRateOptR: '0.075188178902275',
                implRoyaltyRateAvgR: '0.080530402588508',
                implRoyaltyRateCaut0: '0.14417905080508',
                implRoyaltyRateOpt0: '0.1331690202951',
                implRoyaltyRateAvg0: '0.13867403555009',
                custValueRevenue: '0.091891891891892',
                custValueUSD: '2.0076235',
                custTab: true,
                ndCust: '10',
                implCustMargCaut: '0.019904581474258',
                implCustMargOpt: '0.015947708885754',
                implCustMargAvg: '0.017926145180006',
                attritionRate: '0.095162582015334',
                marginType: 'distributor margin',
                gwRev: '0.69189189189189',
                gwUsd: '15.116224',
                gwTab: true,
                ndGw: '200',
                implGwMargCaut: '0.091286783296829',
                implGwMargOpt: '0.063345429583287',
                implGwMargAvg: '0.077316106440058',
                gwPerStaffThUsd: '37.79056',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                gwPerStaffTHLC: '32',
                revPerStaffThUsd: '54.61916875',
                createdAt: '2021-01-19T12:02:25+01:00',
                updatedAt: '2021-01-19T17:22:12+01:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '186',
                    code: 'SE',
                    isEU: true,
                    isG7: false,
                    isG20: false,
                    vat: 0.25,
                    name: 'Sweden',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: {
                        type: 'currencies',
                        id: '1',
                    },
                    region: {
                        type: 'regions',
                        id: '4',
                    },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '179',
                    code: 'RO',
                    isEU: true,
                    isG7: false,
                    isG20: false,
                    vat: 0.19,
                    name: 'Romania',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: {
                        type: 'currencies',
                        id: '1',
                    },
                    region: {
                        type: 'regions',
                        id: '4',
                    },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: {
                    type: 'concepts',
                    id: '1',
                    name: 'fair value',
                },
                cpcs: [
                    {
                        type: 'cpcs',
                        id: '4106',
                    },
                ],
                territory: {
                    type: 'territories',
                    id: '3',
                    comment: 'small part of the home country (< 20%)',
                    name: 'local',
                },
                currency: {
                    type: 'currencies',
                    id: '44',
                    code: 'EUR',
                    name: 'Euro',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: {
                    type: 'profit_types',
                    id: '3',
                    name: 'EBITDA',
                },
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '53073',
            prodGroup: 'g',
            brand: {
                type: 'brands',
                id: '13326',
                importId: 53073,
                isTrademark: true,
                isCustomerRelation: true,
                isGoodwill: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'NRW Holdings Ltd',
                brandBusinessComb: 'Golding Group Pty Ltd',
                activities:
                    'Golding is a market leading, highly reputable Queensland based civil infrastructure,' +
                    ' urban and mining services contractor operating across three core divisions: Civil, Mining,' +
                    ' Urban. The principal activities of Golding Group Pty Ltd (Golding) include: Civil Construction' +
                    ' including bulk earthworks and infrastructure development capability in relation to ' +
                    'roads, rail, bridges and ports; Urban Solutions including earthworks, drainage, ' +
                    'roads, energy and water infrastructure projects; and Mining Services including mine' +
                    ' development and operations from construction of mine-site infrastructure and removal' +
                    ' of overburden and topsoil to open cut mining. Services include specialist mine site ' +
                    'rehabilitation works, environmental dam construction, and reclamation earthworks. ' +
                    'Golding was established in 1942, with origins in Gladstone and Bowen Basin, with a ' +
                    'focus on the east coast of Australia. Golding’s unaudited financial year ended 30 June ' +
                    '2017 reported revenue of AUD369m, EBITDA of AUD53m and an order book of around AUD500m,' +
                    ' with AUD275m scheduled for delivery in FY18.',
                activitiesMain:
                    'civil infrastructure, urban and mining services contractor',
                valuationYear: 2017,
                totalAssets: '146.156',
                enterpriseValue: '74.262',
                revenues: '369',
                trademarkValue: '8.916',
                usefulLifetime: null,
                customerValue: '18.892',
                lifetimeCv: '5',
                goodwill: '40.103',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.0024437373234734',
                royaltyRateReported: null,
                trademarkValuationEV: '0.1200614042175',
                profit: '53',
                costSynergies: null,
                acqPremium: null,
                staffMembers: '700',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '1.329',
                tangibles: '76.916',
                trademarkPerRevenue: '0.024162601626016',
                enterpriseValuePerProfit: '1.4011698113208',
                enterpriseValuePerRevenue: '0.20125203252033',
                trademarkPerTotalAssets: '0.061003311530146',
                customerRelationPerTotalAssets: '0.12925914775993',
                otherIntangiblesPerTotalAssets: '0.0090930238922795',
                goodwillPerTotalAssets: '0.27438490380142',
                tangiblesPerTotalAssets: '0.52625961301623',
                trademarkPerEV: '0.1200614042175',
                customerRelationPerEV: '0.25439659583636',
                otherIntangiblesPerEV: '0.017896097600388',
                goodwillPerEV: '0.5400204680725',
                tangiblesPerEV: '1.0357383318521',
                sum: '1.9681128975788',
                corpTax: '0.3',
                usdRevenues: '282.912669',
                usdBrandVal: '6.835906116',
                implRoyaltyRateCautR: '0.0029015139407467',
                implRoyaltyRateOptR: '0.0019859607062',
                implRoyaltyRateAvgR: '0.0024437373234734',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '0.05119783197832',
                custValueUSD: '14.484515292',
                custTab: false,
                ndCust: '5',
                implCustMargCaut: '0.021183878185277',
                implCustMargOpt: '0.018532837535261',
                implCustMargAvg: '0.019858357860269',
                attritionRate: '0.18126924701484',
                marginType: 'excess earnings margin',
                gwRev: '0.10868021680217',
                gwUsd: '30.747010203',
                gwTab: false,
                ndGw: '200',
                implGwMargCaut: '0.018452138956894',
                implGwMargOpt: '0.01300269345677',
                implGwMargAvg: '0.015727416206832',
                gwPerStaffThUsd: '43.92430029',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                gwPerStaffTHLC: '57.29',
                revPerStaffThUsd: '404.16095571429',
                createdAt: '2021-01-19T12:02:27+01:00',
                updatedAt: '2021-01-19T17:22:12+01:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '13',
                    code: 'AU',
                    isEU: false,
                    isG7: false,
                    isG20: true,
                    vat: 0,
                    name: 'Australia',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '2' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '13',
                    code: 'AU',
                    isEU: false,
                    isG7: false,
                    isG20: true,
                    vat: 0,
                    name: 'Australia',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '2' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2496' },
                    { type: 'cpcs', id: '2497' },
                    {
                        type: 'cpcs',
                        id: '2502',
                    },
                    { type: 'cpcs', id: '2503' },
                    { type: 'cpcs', id: '2504' },
                    { type: 'cpcs', id: '2505' },
                    {
                        type: 'cpcs',
                        id: '2523',
                    },
                ],
                territory: {
                    type: 'territories',
                    id: '5',
                    comment: 'part of the home country (< 50%)',
                    name: 'regional',
                },
                currency: {
                    type: 'currencies',
                    id: '8',
                    code: 'AUD',
                    name: 'Australia Dollar',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: { type: 'profit_types', id: '3', name: 'EBITDA' },
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '58386',
            prodGroup: 'g',
            brand: {
                type: 'brands',
                id: '13597',
                importId: 58386,
                isTrademark: true,
                isCustomerRelation: true,
                isGoodwill: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Softbank Group Corp.',
                brandBusinessComb: 'ZOZO, Inc.',
                activities:
                    'ZOZO Inc. (TYO: 3092) is a leading' +
                    ' online fashion retailer headquartered in Japan. ZOZO, ' +
                    'Inc., formerly START TODAY CO., LTD. is a Japan-based company engaged in ' +
                    'the E-commerce (EC) business which operates Internet shopping Websites. The ' +
                    'Company’s business includes ZOZOTOWN business, PB business, BtoB business, advertising' +
                    ' business and other business. The ZOZOTOWN business consists of the purchasing shop,' +
                    ' contracted shop and ZOZOUSED business. PB business sells the Company-designed apparel' +
                    ' products tailored to the individual shape of the users. The B to B business supports ' +
                    'various fulfillment related businesses, such as system development, design production, ' +
                    'logistics contracting, marketing support of EC sites operated independently by apparel' +
                    " makers. The advertising business uses ZOZOTOWN and WAR's user reach base to provide" +
                    ' advertising space to client brands and advertising agencies and earns advertising ' +
                    'revenue. The others business includes business associated with ZOZOTOWN, such as paid' +
                    ' member revenue, shipping income and settlement fee income. ZOZO’s retails brands like' +
                    ' adidas Japan K.K., Adastria Co., Ltd., URBAN RESEARCH Co., LTD., UNDERCOVER, A-net Inc., ' +
                    'SHIPS LTD., JOI’X CORPORATION, TOKYO BASE Co.,Ltd., TOMORROWLAND Co.,Ltd., Nike, Inc., NANO' +
                    '・UNIVERSE CO.,LTD., NOWHERE CO., LTD., Baroque Japan Limited., B’s INTERNATIONAL,' +
                    ' BEAMS Co., Ltd., UNITED ARROWS LTD., Wacoal Corp., World Co., Ltd., JUN CO.,LTD., ' +
                    'DIESEL JAPAN CO.,LTD., BAYCREW’S CO., LTD., Ralph Lauren Japan, and others.',
                activitiesMain: 'online fashion retailer',
                valuationYear: 2019,
                totalAssets: '820390',
                enterpriseValue: '563611',
                revenues: '124542',
                trademarkValue: '178720',
                usefulLifetime: null,
                customerValue: '322070',
                lifetimeCv: '25',
                goodwill: '212911',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.14592564161213',
                royaltyRateReported: null,
                trademarkValuationEV: '0.31709814038406',
                profit: null,
                costSynergies: null,
                acqPremium: '0.21',
                staffMembers: '1158',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '2227',
                tangibles: '104462',
                trademarkPerRevenue: '1.4350179056061',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '4.525469319587',
                trademarkPerTotalAssets: '0.21784760906398',
                customerRelationPerTotalAssets: '0.39258157705482',
                otherIntangiblesPerTotalAssets: '0.0027145625860871',
                goodwillPerTotalAssets: '0.25952412876802',
                tangiblesPerTotalAssets: '0.12733212252709',
                trademarkPerEV: '0.31709814038406',
                customerRelationPerEV: '0.57144023093942',
                otherIntangiblesPerEV: '0.0039513068410659',
                goodwillPerEV: '0.37776232188513',
                tangiblesPerEV: '0.18534414693823',
                sum: '1.4555961469879',
                corpTax: '0.3062',
                usdRevenues: '1143.046476',
                usdBrandVal: '1640.29216',
                implRoyaltyRateCautR: '0.17328952358477',
                implRoyaltyRateOptR: '0.11856175963949',
                implRoyaltyRateAvgR: '0.14592564161213',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '2.5860352330941',
                custValueUSD: '2955.95846',
                custTab: true,
                ndCust: '25',
                implCustMargCaut: '0.45374217826211',
                implCustMargOpt: '0.32560094308167',
                implCustMargAvg: '0.38967156067189',
                attritionRate: '0.039210560869463',
                marginType: 'excess earnings margin',
                gwRev: '1.7095517977871',
                gwUsd: '1954.097158',
                gwTab: true,
                ndGw: '200',
                implGwMargCaut: '0.25550457596741',
                implGwMargOpt: '0.17455024151459',
                implGwMargAvg: '0.215027408741',
                gwPerStaffThUsd: '1687.4759568221',
                synergieValue: '',
                acqPrmValue: '118358.31',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '0.21',
                gwPerStaffTHLC: '183860.9671848',
                revPerStaffThUsd: '987.08676683938',
                createdAt: '2021-01-19T12:02:27+01:00',
                updatedAt: '2021-01-19T17:22:13+01:00',
                technologyAsset: '',
                technologyUsefulLife: '',
                otherIntangiblesTech: '',
                techPerTotalAssets: '',
                techPerEV: '',
                techValueRev: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '106',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Japan',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '106',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Japan',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2829' },
                    { type: 'cpcs', id: '2830' },
                ],
                territory: {
                    type: 'territories',
                    id: '4',
                    comment: 'home country',
                    name: 'national',
                },
                currency: {
                    type: 'currencies',
                    id: '71',
                    code: 'JPY',
                    name: 'Japan Yen',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '50403',
            prodGroup: 'e',
            brand: {
                type: 'brands',
                id: '14129',
                importId: 50403,
                isTrademark: false,
                isCustomerRelation: false,
                isGoodwill: false,
                isTechnology: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Construcciones y Auxiliar de Ferrocarriles SA',
                brandBusinessComb: 'Solaris Bus & Coach S.A.',
                activities:
                    'Solaris, established in 1996, is a global supplier of conventional and electric buses with presence in over 700 cities in 32 countries. With a 2017 turnover of close to €450 million, it has production plants in Poland in the cities of Bolechowo and Sroda, and a workforce of more than 2,300 people. The main markets where Solaris operates are Poland, Germany, Italy, Scandinavia and the Baltics. In 2017, the company delivered 1,397 buses, including conventional models (diesel and CNG) and a growing number of e-mobility vehicles, where it offers the widest available range of solutions, e.g. hybrid buses, trolleybuses, full-battery and hydrogen fuel cell powered public transport vehicles. Additionally, the company offers related services, such as maintenance and spare parts. In 2017, Solaris Urbino electric bus was awarded the prestigious “Bus of The Year” title. July 3rd, 2018. Solaris arose from the enterprise Neoplan Polska established in 1994.',
                activitiesMain:
                    'electric busses, hybrid buses, trolleybuses, full-battery and hydrogen fuel cell powered public transport vehicles',
                valuationYear: 2018,
                totalAssets: '655.051',
                enterpriseValue: '352.319',
                revenues: '444',
                trademarkValue: '48',
                usefulLifetime: null,
                customerValue: '9.537',
                lifetimeCv: '15',
                goodwill: '92.436',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.010028083656646',
                royaltyRateReported: null,
                trademarkValuationEV: '0.13624016871074',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: '2319',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '86.316',
                tangibles: '418.762',
                trademarkPerRevenue: '0.10810810810811',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '0.79351126126126',
                trademarkPerTotalAssets: '0.073276737231147',
                customerRelationPerTotalAssets: '0.014559171728614',
                otherIntangiblesPerTotalAssets: '0.13176989272591',
                goodwillPerTotalAssets: '0.14111267672288',
                tangiblesPerTotalAssets: '0.63928152159145',
                trademarkPerEV: '0.13624016871074',
                customerRelationPerEV: '0.027069218520716',
                otherIntangiblesPerEV: '0.24499388338409',
                goodwillPerEV: '0.26236450489471',
                tangiblesPerEV: '1.188587615201',
                sum: '1.8592553907113',
                corpTax: '0.19',
                usdRevenues: '524.34402',
                usdBrandVal: '56.68584',
                implRoyaltyRateCautR: '0.011874252163316',
                implRoyaltyRateOptR: '0.0081819151499757',
                implRoyaltyRateAvgR: '0.010028083656646',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '0.02147972972973',
                custValueUSD: '11.262767835',
                custTab: true,
                ndCust: '15',
                implCustMargCaut: '0.0040166683982294',
                implCustMargOpt: '0.0030742567235952',
                implCustMargAvg: '0.0035454625609123',
                attritionRate: '0.064493015003737',
                marginType: 'distributor margin"',
                gwRev: '0.20818918918919',
                gwUsd: '109.16275638',
                gwTab: true,
                ndGw: '200',
                implGwMargCaut: '0.028106695490547',
                implGwMargOpt: '0.0194443613512',
                implGwMargAvg: '0.023775528420874',
                gwPerStaffThUsd: '47.07320240621',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                gwPerStaffTHLC: '39.860284605433',
                revPerStaffThUsd: '226.10781371281',
                createdAt: '2022-05-20T12:10:55+00:00',
                updatedAt: '2022-05-20T12:10:55+00:00',
                technologyAsset: '80',
                technologyUsefulLife: '20',
                otherIntangiblesTech: '6.316',
                techPerTotalAssets: '0.12212789538525',
                techPerEV: '0.22706694785124',
                techValueRev: '0.18018018018018',
                implTechMargCautNoObs: '0.025330863475636',
                implTechMargOptNoObs: '0.019328402820563',
                implTechMargAvgNoObs: '0.022329633148099',
                implTechMargCautObs: '0.041670512589435',
                implTechMargOptObs: '0.034859120693896',
                implTechMargAvgObs: '0.03826481664166',
                otherIntangTechPerTotalAssets: '0.0096419973406651',
                otherIntangTechPerEV: '0.017926935532855',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '94.4764',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '63',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Spain',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '169',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Poland',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2829' },
                    { type: 'cpcs', id: '2830' },
                ],
                territory: {
                    type: 'territories',
                    id: '4',
                    comment: 'home country',
                    name: 'international',
                },
                currency: {
                    type: 'currencies',
                    id: '71',
                    code: 'EUR',
                    name: 'Euro',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '61219',
            prodGroup: 'e',
            brand: {
                type: 'brands',
                id: '14349',
                importId: 61219,
                isTrademark: false,
                isCustomerRelation: false,
                isGoodwill: false,
                isTechnology: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Masco Corp.',
                brandBusinessComb: 'The L.D. Kirchler Co.',
                activities:
                    'Kichler, based in Cleveland, Ohio, is a leading developer of decorative residential and light commercial lighting products, ceiling fans and LED lighting systems across both consumer and professional distribution channels. Kichler had revenues of approximately $450 million in 2017 and employs approximately 700 people worldwide.',
                activitiesMain: 'residential and commercial lighting products',
                valuationYear: 2018,
                totalAssets: '608',
                enterpriseValue: '549',
                revenues: '450',
                trademarkValue: '59',
                usefulLifetime: null,
                customerValue: '145',
                lifetimeCv: '20',
                goodwill: '64',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.012927560265107',
                royaltyRateReported: null,
                trademarkValuationEV: '0.10746812386157',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: '700',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '36',
                tangibles: '304',
                trademarkPerRevenue: '0.13111111111111',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '1.22',
                trademarkPerTotalAssets: '0.09703947368421',
                customerRelationPerTotalAssets: '0.23848684210526',
                otherIntangiblesPerTotalAssets: '0.059210526315789',
                goodwillPerTotalAssets: '0.10526315789474',
                tangiblesPerTotalAssets: '0.5',
                trademarkPerEV: '0.10746812386157',
                customerRelationPerEV: '0.26411657559198',
                otherIntangiblesPerEV: '0.065573770491803',
                goodwillPerEV: '0.11657559198543',
                tangiblesPerEV: '0.55373406193078',
                sum: '1.1074681238616',
                corpTax: '0.27',
                usdRevenues: '450',
                usdBrandVal: '59',
                implRoyaltyRateCautR: '0.015337391884295',
                implRoyaltyRateOptR: '0.010517728645918',
                implRoyaltyRateAvgR: '0.012927560265107',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '0.32222222222222',
                custValueUSD: '145',
                custTab: true,
                ndCust: '20',
                implCustMargCaut: '0.058314890951519',
                implCustMargOpt: '0.04293385743636',
                implCustMargAvg: '0.05062437419394',
                attritionRate: '0.048770575526248',
                marginType: 'excess earnings margin',
                gwRev: '0.14222222222222',
                gwUsd: '64',
                gwTab: true,
                ndGw: '200',
                implGwMargCaut: '0.020545249179951',
                implGwMargOpt: '0.014093007054629',
                implGwMargAvg: '0.02377501731912811729528420874',
                gwPerStaffThUsd: '91.428571428571',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                gwPerStaffTHLC: '91.428571428571',
                revPerStaffThUsd: '642.85714285714',
                createdAt: '2022-05-20T12:10:55+00:00',
                updatedAt: '2022-05-20T12:10:55+00:00',
                technologyAsset: '36',
                technologyUsefulLife: '3',
                otherIntangiblesTech: '0',
                techPerTotalAssets: '',
                techPerEV: '0.08',
                techValueRev: '0.18018018018018',
                implTechMargCautNoObs: '0.036802874025932',
                implTechMargOptNoObs: '0.033286000061362',
                implTechMargAvgNoObs: '0.035044437043647',
                implTechMargCautObs: '0.056927287977394',
                implTechMargOptObs: '0.053296686202867',
                implTechMargAvgObs: '0.05511198709013',
                otherIntangTechPerTotalAssets: '0',
                otherIntangTechPerEV: '0',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '94.4764',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '63',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '169',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2829' },
                    { type: 'cpcs', id: '2830' },
                ],
                territory: {
                    type: 'territories',
                    id: '4',
                    comment: 'home country',
                    name: 'international',
                },
                currency: {
                    type: 'currencies',
                    id: '71',
                    code: 'USD',
                    name: 'United States Dollar',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '61183',
            prodGroup: 'e',
            brand: {
                type: 'brands',
                id: '14345',
                importId: 61183,
                isTrademark: false,
                isCustomerRelation: false,
                isGoodwill: false,
                isTechnology: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Infineon Technologies AG',
                brandBusinessComb: 'Cypress Semiconductor Corporation',
                activities:
                    'Cypress Semiconductors Corporation (NASDAQ: CY) is the leader in advanced embedded solutions for the world’s most innovative automotive, industrial, smart home appliances, consumer electronics and medical products. Cypress’s microcontrollers, wireless and USB-based connectivity solutions, analog ICs, and reliable, high-performance memories help engineers design differentiated products and get them to market first. Cypress is committed to providing customers with the best support and development resources on the planet enabling them to disrupt markets by creating new product categories in record time. Cypress designs, manufactures and sells advanced embedded system solutions for Internet of Things ("IoT"), automotive, industrial, and consumer applications. Cypress microcontrollers, analog integrated circuits ("ICs"), wireless and wired connectivity solutions and memories help engineers design differentiated products and help with speed to market. Cypress is committed to providing customers with quality support and engineering resources. Cypress was incorporated in California in December 1982. Cypress currently operates under two reportable business segments: Microcontroller and Connectivity Division ("MCD") and Memory Products Division ("MPD"). MCD focuses on connect and compute solutions for the Internet of Things and automotive solutions that enhance the in-cabin user experience. MCD offerings include robust wireless and wired connectivity solutions that combine with flexible, high-performance microcontroller ("MCU") and analog solutions, backed with a focus on superior design software. The portfolio includes Wi-Fi®, Bluetooth®, Bluetooth Low Energy ("BLE") and Wi-Fi plus Bluetooth combo solutions; Traveo® automotive MCUs, PSoC® programmable MCUs and general-purpose MCUs; CapSense® capacitive-sensing controllers and automotive TrueTouch® touchscreen solutions; a broad line of USB controllers, including solutions for the USB-C and USB Power Delivery standards; and analog PMIC Power Management ICs. This division also includes our intellectual property ("IP") business. MPD focuses on fail-safe storage and datalogging solutions for mission critical applications including the automotive end market. The portfolio includes specialized, high-performance parallel and serial NOR flash memories, static random access memories ("SRAM"), F-RAM™ ferroelectric memory devices, nonvolatile SRAMs ("nvSRAM"), clocks, nonvolatile DIMM ("NVDIMM"), PowerGEM® energy modules and other specialty memories. Our "flexible manufacturing" strategy combines capacity from external foundries with output from our internal manufacturing facilities which allows us to meet fluctuations in customer demand while limiting capital expenditure requirements and lessening the burden of high fixed costs, a capability that is important with our rapidly evolving product portfolio and revenue growth. As of the end of fiscal year 2019, we owned a wafer fabrication facility in Austin, Texas. External wafer foundries, mainly in Asia, manufactured approximately 60% of our wafers (8 inch equivalent) in fiscal 2019. External foundries that we partnered with during 2019 included HuaHong Grace Semiconductor Manufacturing Corporation, Semiconductor Manufacturing International Corporation, Skywater Technologies Inc., Taiwan Semiconductor Manufacture Company, United Microelectronics Corporation and Wuhan Xinxin Semiconductor Manufacturing Corporation. We conduct assembly and test operations at our back-end manufacturing facilities in Cavite, Philippines and Bangkok, Thailand, which allows us to effectively manage our manufacturing cost. External assembly and test subcontractors in Asia accounted for approximately 72% of the total assembly output and 62% of the total test output in fiscal 2019. External assembly and test subcontractors that we partnered with during 2019 included Advanced Semiconductor Engineering, Inc., Amkor Technology, Deca Technologies Inc., Fujitsu Semiconductor Limited and United Test and Assembly Center Ltd.',
                activitiesMain:
                    'electronics; microcontrollers, connectivity solutions, Ics',
                valuationYear: 2020,
                totalAssets: '10885',
                enterpriseValue: '8816',
                revenues: '1886',
                trademarkValue: '96',
                usefulLifetime: '5',
                customerValue: '998',
                lifetimeCv: '12',
                goodwill: '5430',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.014256902159662',
                royaltyRateReported: null,
                trademarkValuationEV: '0.010889292196007',
                profit: null,
                costSynergies: '180',
                acqPremium: '0.34',
                staffMembers: '5871',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '2014',
                tangibles: '2347',
                trademarkPerRevenue: '0.050901378579003',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '4.6744432661718',
                trademarkPerTotalAssets: '0.0088194763435921',
                customerRelationPerTotalAssets: '0.091685806155259',
                otherIntangiblesPerTotalAssets: '0.18502526412494',
                goodwillPerTotalAssets: '0.49885163068443',
                tangiblesPerTotalAssets: '0.21561782269178',
                trademarkPerEV: '0.010889292196007',
                customerRelationPerEV: '0.11320326678766',
                otherIntangiblesPerEV: '0.22844827586207',
                goodwillPerEV: '0.61592558983666',
                tangiblesPerEV: '0.26622050816697',
                sum: '1.2346869328494',
                corpTax: '0.27',
                usdRevenues: '2154.181656',
                usdBrandVal: '109.650816',
                implRoyaltyRateCautR: '0.015050958994217',
                implRoyaltyRateOptR: '0.013462845325107',
                implRoyaltyRateAvgR: '0.014256902159662',
                implRoyaltyRateCaut0: '0.025725430674868',
                implRoyaltyRateOpt0: '0.023740663272417',
                implRoyaltyRateAvg0: '0.024733046973643',
                custValueRevenue: '0.52916224814422',
                custValueUSD: '1139.911608',
                custTab: true,
                ndCust: '12',
                implCustMargCaut: '0.11515625938693',
                implCustMargOpt: '0.08926407006301',
                implCustMargAvg: '0.10221016472497',
                attritionRate: '0.07995558541414',
                marginType: 'distributor margin',
                gwRev: '2.8791092258749',
                gwUsd: '6202.12428',
                gwTab: true,
                ndGw: '200',
                implGwMargCaut: '0.41591261574771',
                implGwMargOpt: '0.28529512475134',
                implGwMargAvg: '0.35060387024952',
                gwPerStaffThUsd: '1056.3999795606',
                synergieValue: '1440',
                acqPrmValue: '2997.44',
                earnoutPerEV: '',
                synergiePerEV: '0.16333938294011',
                acqPremPerEV: '0.34',
                gwPerStaffTHLC: '924.88502810424',
                revPerStaffThUsd: '366.91903525805',
                createdAt: '2022-05-20T12:10:55+00:00',
                updatedAt: '2022-05-20T12:10:55+00:00',
                technologyAsset: '2011',
                technologyUsefulLife: '12',
                otherIntangiblesTech: '3',
                techPerTotalAssets: '0.1847496554892',
                techPerEV: '0.22810798548094',
                techValueRev: '1.0662778366914',
                implTechMargCautNoObs: '0.18982030578424',
                implTechMargOptNoObs: '0.15241565304216',
                implTechMargAvgNoObs: '0.1711179794132',
                implTechMargCautObs: '0.33064245966399',
                implTechMargOptObs: '0.28699366880843',
                implTechMargAvgObs: '0.30881806423621',
                otherIntangTechPerTotalAssets: '0.00027560863573725',
                otherIntangTechPerEV: '0.00034029038112523',
                swPerTotalAssets: '',
                swPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techValueUsd: '94.4764',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '',
                softwareRoyaltyRateReported: '',
                swValueRev: '',
                swValueUsd: '',
                implSwMargCautNoObs: '',
                implSwMargOptNoObs: '',
                implSwMargAvgNoObs: '',
                implSwMargCautObs: '',
                implSwMargOptObs: '',
                implSwMargAvgObs: '',
                valuerCountry: {
                    type: 'countries',
                    id: '63',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Germany',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '169',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2829' },
                    { type: 'cpcs', id: '2830' },
                ],
                territory: {
                    type: 'territories',
                    id: '4',
                    comment: 'home country',
                    name: 'international',
                },
                currency: {
                    type: 'currencies',
                    id: '44',
                    code: 'EUR',
                    name: 'Euro',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '65404',
            prodGroup: 's',
            brand: {
                type: 'brands',
                id: '25067',
                importId: 65404,
                isTrademark: false,
                isCustomerRelation: false,
                isGoodwill: false,
                isTechnology: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Charge Point Holdings, Inc.',
                brandBusinessComb: 'has·to·be GmbH',
                activities:
                    'has·to·be is an e-mobility provider with a leading European charging software platform. Founded in 2013, has·to·be today has 125 employees in Austria and Germany, as well as approximately 40,000 networked ports and over 250,000 networked ports through open roaming agreements. has·to·be boasts over 1,000 customers in a variety of sectors, from automotive and fleet to oil and gas and energy, from leading brands such as Aral, Audi, GP Joule, Ionity and Porsche. The expansive has·to·be software platform effectively addresses the complexity and fragmentation of today’s European charging landscape and is compatible with widely deployed European charging stations and e-mobility services. has·to·be paves the way for sustainable mobility. With its comprehensive EV charging solution platform and innovative services, has·to·be provides the platform companies require to enjoy success in the field of EV charging: from the scalable operation of charging infrastructure to the end-to-end management of worldwide mobility solutions. has·to·be gmbh is headquartered in the federal province of Salzburg and has offices in Munich and Vienna. Founded in 2013, has·to·be started with a small network of over 400 charging stations as a part of the E-WALD charging infrastructure project in Bavaria, Germany. With Volkswagen as a key investor and stakeholder, it quickly expanded to add over 100 employees in Germany and Austria, 40,000 managed charging points, and 250,000 roaming charging points, with more than 1,000 customers and projects in 45-plus countries. It also has 4,700 ports included in ChargePoint’s network.',
                activitiesMain: 'software platform for e-mobility charging',
                valuationYear: 2021,
                totalAssets: '262.101',
                enterpriseValue: '238.667',
                revenues: '15',
                trademarkValue: '48',
                usefulLifetime: null,
                customerValue: '78.728',
                softwareValue: '12.712',
                lifetimeCv: '15',
                goodwill: '92.436',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.010028083656646',
                royaltyRateReported: null,
                trademarkValuationEV: '0.13624016871074',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: '125',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '12.712',
                tangibles: '11.664',
                trademarkPerRevenue: '0',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '15.911133333333',
                trademarkPerTotalAssets: '0',
                customerRelationPerTotalAssets: '0.30037275706693',
                otherIntangiblesPerTotalAssets: '0.048500387255295',
                goodwillPerTotalAssets: '0.60662492703195',
                techPerTotalAssets: '',
                swPerTotalAssets: '0.048500387255295',
                tangiblesPerTotalAssets: '0.044501928645827',
                trademarkPerEV: '0',
                customerRelationPerEV: '0.32986546108176',
                otherIntangiblesPerEV: '0.053262495443442',
                goodwillPerEV: '0.6661876170564',
                techPerEV: '',
                swPerEV: '0.053262495443442',
                tangiblesPerEV: '0.048871440123687',
                sum: '1.0981870137053',
                corpTax: '0.25',
                usdRevenues: '15',
                usdBrandVal: '0',
                implRoyaltyRateCautR: '',
                implRoyaltyRateOptR: '',
                implRoyaltyRateAvgR: '',
                implRoyaltyRateCaut0: '',
                implRoyaltyRateOpt0: '',
                implRoyaltyRateAvg0: '',
                custValueRevenue: '5.2485333333333',
                custValueUSD: '78.728',
                custTab: true,
                ndCust: '10',
                implCustMargCaut: '1.2175740747234',
                implCustMargOpt: '0.96453458462017',
                implCustMargAvg: '1.0910543296718',
                attritionRate: '0.095162582015334',
                marginType: 'excess earnings margin',
                gwRev: '10.5998',
                gwUsd: '158.997',
                gwTab: true,
                ndGw: '200',
                implGwMargCaut: '1.6796959224563',
                implGwMargOpt: '1.1836335739346',
                implGwMargAvg: '1.4316647481954',
                gwPerStaffThUsd: '1271.976',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                gwPerStaffTHLC: '1271.976',
                revPerStaffThUsd: '120',
                technologyAsset: '',
                technologyUsefulLife: '',
                techValueRev: '',
                techValueUsd: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangiblesTech: '3.5527136788005E-15',
                otherIntangTechPerTotalAssets: '1.3554750568676E-17',
                otherIntangTechPerEV: '1.4885651048534E-17',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '6',
                softwareRoyaltyRateReported: '',
                swValueRev: '0.84746666666667',
                swValueUsd: '12.712',
                implSwMargCautNoObs: '0.22060296950894',
                implSwMargOptNoObs: '0.19136490345135',
                implSwMargAvgNoObs: '0.20598393648015',
                implSwMargCautObs: '0.3833010837584',
                implSwMargOptObs: '0.34947585179941',
                implSwMargAvgObs: '0.3663884677789',
                createdAt: '2022-06-15T08:06:38+00:00',
                updatedAt: '2022-06-15T08:06:38+00:00',
                valuerCountry: {
                    type: 'countries',
                    id: '63',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'United States',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '169',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Austria',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2829' },
                    { type: 'cpcs', id: '2830' },
                ],
                territory: {
                    type: 'territories',
                    id: '4',
                    comment: 'home country',
                    name: 'international',
                },
                currency: {
                    type: 'currencies',
                    id: '71',
                    code: 'USD',
                    name: 'United States Dollar',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '65290',
            prodGroup: 's',
            brand: {
                type: 'brands',
                id: '25029',
                importId: 65290,
                isTrademark: false,
                isCustomerRelation: false,
                isGoodwill: false,
                isTechnology: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Massmart Holdings Ltd',
                brandBusinessComb: 'OneCart Proprietary Limited',
                activities:
                    'OneCart Proprietary Limited is a fast moving consumer goods market place and logistics platform that partners with leading retailers in South Africa to enable fast, flexible and efficient online sales and home delivery to consumers across the country. The platform provides access to products across the dry grocery, frozen and fresh foods, liquor, baby, health and beauty, household and pet supplies categories; all made available to consumers via a single shopping interface. Developer of an online grocery marketplace intended to facilitate flexibility and convenience among online shoppers. The companys platform connects multiple retailers to the consumers and retailers displayed are based on the consumers geographical location, and the platform allows customers to shop for household items such as groceries and fast-moving consumer goods, from multiple national retailers in one cart that offers delivery of purchased products within 2 hours at the clients desired location, enabling consumers to save time and money in shopping.',
                activitiesMain: 'online food delivery marketplace',
                valuationYear: 2021,
                totalAssets: '321.9',
                enterpriseValue: '269.1',
                revenues: '96.4',
                trademarkValue: '10.1',
                usefulLifetime: '6',
                customerValue: '34.5',
                softwareValue: '14.2',
                lifetimeCv: '3',
                goodwill: '258.5',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0.025582605773435',
                royaltyRateReported: null,
                trademarkValuationEV: '0.037532515793385',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: '850',
                contingentOrEarnout: null,
                comments: null,
                otherIntangibles: '14.2',
                tangibles: '4.6',
                trademarkPerRevenue: '0.10477178423236',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '2.7914937759336',
                trademarkPerTotalAssets: '0.031376203789997',
                customerRelationPerTotalAssets: '0.1071761416589',
                otherIntangiblesPerTotalAssets: '0.044113078595837',
                goodwillPerTotalAssets: '0.80304442373408',
                techPerTotalAssets: '',
                swPerTotalAssets: '0.044113078595837',
                tangiblesPerTotalAssets: '0.014290152221187',
                trademarkPerEV: '0.037532515793385',
                customerRelationPerEV: '0.12820512820513',
                otherIntangiblesPerEV: '0.052768487551096',
                goodwillPerEV: '0.96060943887031',
                techPerEV: '',
                swPerEV: '0.052768487551096',
                tangiblesPerEV: '0.017094017094017',
                sum: '1.1962095875139',
                corpTax: '0.28',
                usdRevenues: '6.5299432',
                usdBrandVal: '0.6841538',
                implRoyaltyRateCautR: '0.027200946204585',
                implRoyaltyRateOptR: '0.023964265342286',
                implRoyaltyRateAvgR: '0.025582605773435',
                implRoyaltyRateCaut0: '0.045717565695216',
                implRoyaltyRateOpt0: '0.041976802647001',
                implRoyaltyRateAvg0: '0.043847184171108',
                custValueRevenue: '0.35788381742739',
                custValueUSD: '2.336961',
                custTab: false,
                ndCust: '3',
                implCustMargCaut: '0.20965370075868',
                implCustMargOpt: '0.19157553588236',
                implCustMargAvg: '0.20061461832052',
                attritionRate: '0.28346868956161',
                marginType: 'excess earnings margin',
                gwRev: '2.6815352697095',
                gwUsd: '17.510273',
                gwTab: false,
                ndGw: '200',
                implGwMargCaut: '0.44263451693013',
                implGwMargOpt: '0.31191185750732',
                implGwMargAvg: '0.37727318721873',
                gwPerStaffThUsd: '20.600321176471',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '',
                synergiePerEV: '',
                acqPremPerEV: '',
                gwPerStaffTHLC: '304.11764705882',
                revPerStaffThUsd: '7.6822861176471',
                technologyAsset: '',
                technologyUsefulLife: '',
                techValueRev: '',
                techValueUsd: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangiblesTech: '1.2434497875802E-14',
                otherIntangTechPerTotalAssets: '3.8628449443311E-17',
                otherIntangTechPerEV: '4.6207721574886E-17',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '5',
                softwareRoyaltyRateReported: '',
                swValueRev: '0.14730290456431',
                swValueUsd: '0.9618796',
                implSwMargCautNoObs: '0.045043690270484',
                implSwMargOptNoObs: '0.039403554391497',
                implSwMargAvgNoObs: '0.042223622330991',
                implSwMargCautObs: '0.076690192101708',
                implSwMargOptObs: '0.070332636062263',
                implSwMargAvgObs: '0.073511414081985',
                createdAt: '2022-06-15T08:06:38+00:00',
                updatedAt: '2022-06-15T08:06:38+00:00',
                valuerCountry: {
                    type: 'countries',
                    id: '63',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'South Africa',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '169',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'South Africa',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2829' },
                    { type: 'cpcs', id: '2830' },
                ],
                territory: {
                    type: 'territories',
                    id: '4',
                    comment: 'home country',
                    name: 'national',
                },
                currency: {
                    type: 'currencies',
                    id: '71',
                    code: 'ZAR',
                    name: 'South Africa Rand',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
        {
            id: '64891',
            prodGroup: 's',
            brand: {
                type: 'brands',
                id: '24896',
                importId: 64891,
                isTrademark: false,
                isCustomerRelation: false,
                isGoodwill: false,
                isTechnology: true,
                isHalfPriced: false,
                isBlocked: false,
                valuer: 'Bravura Solutions Ltd',
                brandBusinessComb: 'Midwinter Holdings (NSW) Pty Ltd',
                activities:
                    'Midwinter Holdings (NSW) Pty Ltd is a developer of financial planning technology. Midwinter’s award-winning financial planning software, AdviceOS, powers back office administration for financial advisers and drives online self-directed digital advice portals for superannuation funds in Australia. Midwinter’s cloud-based SaaS offering is built using advanced technology and complements Bravura’s product suite in an adjacent and attractive growth market. AdviceOS, Midwinter’s core product, is a natural extension to Bravura’s existing software solutions and client base, sitting alongside retirement savings, investments and life insurance. Founded in 2006, Midwinter provides financial planning software to financial advisers, superannuation funds, dealer groups and accountants. In 2013, Midwinter rebuilt their product and launched AdviceOS, a pure cloud platform that combines advice capabilities across multiple channels and advice types in one cloud-based application. Midwinter have also developed a compelling digital advice solution utilised by some of Australia’s largest super funds.',
                activitiesMain: 'software; financial planning software',
                valuationYear: 2019,
                totalAssets: '53.821',
                enterpriseValue: '48.738',
                revenues: '11.5',
                trademarkValue: '0',
                usefulLifetime: '',
                customerValue: '3.602',
                softwareValue: '8.172',
                lifetimeCv: '7',
                goodwill: '40.479',
                discountRate: 0,
                growthRate: null,
                royaltyRateCalculated: '0',
                royaltyRateReported: null,
                trademarkValuationEV: '0',
                profit: null,
                costSynergies: null,
                acqPremium: null,
                staffMembers: '50',
                contingentOrEarnout: '4.113',
                comments: null,
                otherIntangibles: '8.172',
                tangibles: '1.568',
                trademarkPerRevenue: '0',
                enterpriseValuePerProfit: '',
                enterpriseValuePerRevenue: '4.2380869565217',
                trademarkPerTotalAssets: '0',
                customerRelationPerTotalAssets: '0.066925549506698',
                otherIntangiblesPerTotalAssets: '0.15183664368927',
                goodwillPerTotalAssets: '0.75210419724643',
                techPerTotalAssets: '',
                swPerTotalAssets: '0.15183664368927',
                tangiblesPerTotalAssets: '0.029133609557608',
                trademarkPerEV: '0',
                customerRelationPerEV: '0.073905371578645',
                otherIntangiblesPerEV: '0.16767204234889',
                goodwillPerEV: '0.8305429028684',
                techPerEV: '',
                swPerEV: '0.16767204234889',
                tangiblesPerEV: '0.032172021831015',
                sum: '1.1042923386269',
                corpTax: '0.3',
                usdRevenues: '7.993535',
                usdBrandVal: '0',
                implRoyaltyRateCautR: '0',
                implRoyaltyRateOptR: '0',
                implRoyaltyRateAvgR: '0',
                implRoyaltyRateCaut0: '0',
                implRoyaltyRateOpt0: '0',
                implRoyaltyRateAvg0: '0',
                custValueRevenue: '0.31321739130435',
                custValueUSD: '2.50371418',
                custTab: false,
                ndCust: '7',
                implCustMargCaut: '0.10557992843066',
                implCustMargOpt: '0.089383945947533',
                implCustMargAvg: '0.097481937189095',
                attritionRate: '0.13312210032002',
                marginType: 'distributor margin',
                gwRev: '3.5199130434783',
                gwUsd: '28.13654811',
                gwTab: false,
                ndGw: '200',
                implGwMargCaut: '0.59762417214048',
                implGwMargOpt: '0.42112862529661',
                implGwMargAvg: '0.50937639871855',
                gwPerStaffThUsd: '562.7309622',
                synergieValue: '',
                acqPrmValue: '',
                earnoutPerEV: '0.084390003693217',
                synergiePerEV: '',
                acqPremPerEV: '',
                gwPerStaffTHLC: '809.58',
                revPerStaffThUsd: '159.8707',
                technologyAsset: '',
                technologyUsefulLife: '',
                techValueRev: '',
                techValueUsd: '',
                implTechMargCautNoObs: '',
                implTechMargOptNoObs: '',
                implTechMargAvgNoObs: '',
                implTechMargCautObs: '',
                implTechMargOptObs: '',
                implTechMargAvgObs: '',
                otherIntangiblesTech: '',
                otherIntangTechPerTotalAssets: '',
                otherIntangTechPerEV: '',
                techPerRev: '',
                techMarginAvg: '',
                techMarginLow: '',
                techMarginHigh: '',
                techMarginAvgNoObs: '',
                techMarginLowNoObs: '',
                techMarginHighNoObs: '',
                techMarginAvgObs: '',
                techMarginLowObs: '',
                techMarginHighObs: '',
                softwareUsefulLife: '7',
                softwareRoyaltyRateReported: '',
                swValueRev: '0.71060869565217',
                swValueUsd: '5.68027548',
                implSwMargCautNoObs: '0.17469157664255',
                implSwMargOptNoObs: '0.14791847063067',
                implSwMargAvgNoObs: '0.16130502363661',
                implSwMargCautObs: '0.3062937680001',
                implSwMargOptObs: '0.27529991989456',
                implSwMargAvgObs: '0.29079684394733',
                createdAt: '2022-06-15T08:06:38+00:00',
                updatedAt: '2022-06-15T08:06:38+00:00',
                valuerCountry: {
                    type: 'countries',
                    id: '63',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Australia',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                brandCountry: {
                    type: 'countries',
                    id: '169',
                    code: 'JP',
                    isEU: false,
                    isG7: true,
                    isG20: true,
                    vat: 0,
                    name: 'Australia',
                    classification: {
                        type: 'country_classifications',
                        id: '1',
                    },
                    currency: { type: 'currencies', id: '1' },
                    region: { type: 'regions', id: '1' },
                    relationshipNames: ['classification', 'currency', 'region'],
                },
                valuationCause: {
                    type: 'valuation_causes',
                    id: '1',
                    name: 'PPA - share deal',
                },
                concept: { type: 'concepts', id: '1', name: 'fair value' },
                cpcs: [
                    { type: 'cpcs', id: '2829' },
                    { type: 'cpcs', id: '2830' },
                ],
                territory: {
                    type: 'territories',
                    id: '4',
                    comment: 'home country',
                    name: 'national',
                },
                currency: {
                    type: 'currencies',
                    id: '71',
                    code: 'AUD',
                    name: 'Australia Dollar',
                    countries: [],
                    relationshipNames: ['countries'],
                },
                revenueType: {
                    type: 'revenue_types',
                    id: '12',
                    name: 'revenues from sales of products or services',
                },
                profitType: null,
                children: [],
                relationshipNames: [
                    'valuerCountry',
                    'brandCountry',
                    'valuationCause',
                    'concept',
                    'cpcs',
                    'territory',
                    'currency',
                    'revenueType',
                    'profitType',
                    'children',
                ],
            },
            projects: [
                {
                    createdAt: '2021-05-02T08:37:32+02:00',
                    name: 'goodwill sample',
                },
            ],
        },
    ];

    public getSampleRecord(id: number) {
        const record = this.sampleRecords.filter(
            (sampleRecord: SingleRecordDetailsInterface) =>
                sampleRecord.brand.importId === id,
        );
        if (record.length <= 0) {
            return null;
        }
        return record[0];
    }
}
